import { render, staticRenderFns } from "./listPointsOfSale.vue?vue&type=template&id=6ed240d4&scoped=true&"
import script from "./listPointsOfSale.vue?vue&type=script&lang=js&"
export * from "./listPointsOfSale.vue?vue&type=script&lang=js&"
import style0 from "./listPointsOfSale.vue?vue&type=style&index=0&id=6ed240d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed240d4",
  null
  
)

export default component.exports